var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-tool-tip',{staticClass:"info-tooltip ri-font-14",attrs:{"icon-path":"/images/info-icon-blue.svg"}},[_c('div',{staticClass:"ri-font-weight-bold"},[_vm._v("יש פה כרטיס ששייך לשותפ.ה שלך?")]),_vm._v(" "),_c('div',[_vm._v("את ההסכמה צריך לתת עם מספר תעודת הזהות של הבעלים של הכרטיס.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }